import { InsureIQCoverageStatus, RmaAipCodes } from '@harvestiq/constants';
import { zCalendarDate, zDecimalNullable, zIsoDate } from '@harvestiq/zod';
import { z } from '@harvestiq/zod';
import { dbUserSchema } from '../users/db-user';
import { mediaMetaDataSchema } from '../media/media-meta-data';
import { dbUserProfileSchema } from '../user-profiles/db-user-profile';
import { entityHistorySchema } from '../entities-history/entity-history';
import { policySchema } from '../policies/policy';
import { signingAgentSchema } from '../agents/signing-agent';

export const dbSharedEndorsementSchema = z.object({
  id: z.string().uuid(),
  agentSignedAt: z.coerce.date().nullable(),
  signingAgentId: z.string().uuid().nullable(),
  createdBy: z.string().uuid().nullable(),
  customerSignedAt: z.coerce.date().nullable(),
  externalStatus: z.string().nullable(),
  isExternallyManaged: z.boolean(),
  reinsuranceYear: z.number(),
  policyId: z.string().uuid().nullable(),
  salesEffectiveDate: zIsoDate(),
  endDate: zCalendarDate(),
  status: z.nativeEnum(InsureIQCoverageStatus),
  submittedToAipAt: z.coerce.date().nullable(),
  entityHistoryId: z.string().uuid().nullable(),
  aipCode: z.nativeEnum(RmaAipCodes).nullable(),
  importSourceId: z.string().nullable(),
  canceledByImportSourceId: z.string().nullable().default(null),
  totalPremium: zDecimalNullable(),
  subsidyTotal: zDecimalNullable(),
  producerPremiumTotal: zDecimalNullable(),
  watchedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
  statusUpdatedAt: z.coerce.date().nullable(),
  premiumUpdatedAt: z.coerce.date().nullable(),
  indemnityUpdatedAt: z.coerce.date().nullable(),
  mergedIntoCoverageId: z.string().uuid().nullable(),
  isPre2026BeginningFarmerRancher: z.boolean(),
  isVeteranFarmerRancher: z.boolean(),
  beginningFarmerRancherCropYearCount: z.coerce.number().int().nullable(),
});

const endorsementUserProfileSchema = dbUserSchema
  .omit({ password: true })
  .extend({
    profile: dbUserProfileSchema
      .pick({
        id: true,
        userId: true,
        phones: true,
      })
      .nullable(),
  })
  .nullable();

export const sharedEndorsementSchema = dbSharedEndorsementSchema.extend({
  coveragePdf: mediaMetaDataSchema.nullable(),
  entityHistory: entityHistorySchema.nullable(),
  agent: endorsementUserProfileSchema,
  policy: policySchema.pick({ policyCoverages: true }).nullable(), // picking only policyCoverages as endorsement already has entityHistory and others...
  entityId: z.string().uuid().nullable(), // evergreen
  signingAgent: signingAgentSchema.nullable(),
});

export type SharedEndorsement = z.infer<typeof sharedEndorsementSchema>;
